import { gameState } from '@js/state';

export default class HintScene extends Phaser.Scene {
  constructor() {
    super({
      key: 'HintScene',
    });
  }

  preload() {}

  create() {
    this.overlay = this.add.sprite(0, 0, 'overlay').setVisible(false).setOrigin(0);
    this.hint = this.add
      .sprite(89, 424 + 21, 'hint1')
      .setOrigin(0)
      .setScale(0.9)
      .setVisible(false);
    this.closeHintButton = this.add
      .sprite(491, 401 + 21, 'closeHint')
      .setOrigin(0)
      .setVisible(false)
      .setInteractive({ cursor: 'pointer' });

    this.hintButton = this.add
      .sprite(82, 650, 'hintFinalAnim')
      .setScale(0.8)
      .setVisible(false)
      .setInteractive({ cursor: 'pointer' });

    this.anims.create({
      key: 'pop',
      frames: this.anims.generateFrameNames('hintFinalAnim', {
        start: 0,
        end: 35,
        zeroPad: 0,
        prefix: 'seq_0_',
        suffix: '.png',
      }),
      frameRate: 30,
      repeat: 0,
    });

    this.anims.create({
      key: 'breathe',
      frames: this.anims.generateFrameNames('hintFinalAnim', {
        start: 36,
        end: 66,
        zeroPad: 0,
        prefix: 'seq_0_',
        suffix: '.png',
      }),
      frameRate: 30,
      repeat: -1,
    });

    this.anims.create({
      key: 'idle',
      frames: this.anims.generateFrameNames('hintFinalAnim', {
        start: 36,
        end: 37,
        zeroPad: 0,
        prefix: 'seq_0_',
        suffix: '.png',
      }),
      frameRate: 30,
      repeat: -1,
    });

    this.anims.create({
      key: 'pop_out',
      frames: this.anims.generateFrameNames('hintFinalAnim', {
        start: 35,
        end: 0,
        zeroPad: 0,
        prefix: 'seq_0_',
        suffix: '.png',
      }),
      frameRate: 30,
      repeat: 0,
    });
  }

  hintFunction() {
    if (gameState.hintState == true) {
      // console.log("Called");
      gameState.hintState = false;
      this.hintButton.setVisible(true).setInteractive();
      this.hintButton.play('pop');
      this.hintButton.on(
        Phaser.Animations.Events.ANIMATION_COMPLETE_KEY + 'pop',
        () => {
          this.hintButton.play('breathe');
        },
        this,
      );

      this.hintButton.on(
        'pointerdown',
        function () {
          this.hintButton.stop('breathe');
          this.hintButton.play('idle');
          gameState.hintClicked = true;
          if (gameState.prevHint == 0) {
            gameState.hintUsed += 1;
            gameState.prevHint = gameState.hintUsed;
          }
          // console.log("hintUsed"+gameState.hintUsed);

          this.overlay.setVisible(true);
          this.closeHintButton.setVisible(true);
          this.hint.setVisible(true);
          this.hintButton.disableInteractive();

          if (gameState.wrong == 1) this.hint.setTexture('hint1');
          if (gameState.wrong == 2) this.hint.setTexture('hint2');

          this.closeHintButton.on(
            'pointerdown',
            function () {
              gameState.hintClicked = false;
              gameState.buttonState = '';
              this.overlay.setVisible(false);
              this.hint.setVisible(false);
              this.closeHintButton.setVisible(false);

              this.hintButton.stop('idle');
              this.hintButton.play('pop_out');
              // this.hintButton.on(Phaser.Animations.Events.ANIMATION_COMPLETE_KEY+"pop_out",
              //() => {

              // },this);
            },
            this,
          );
        },
        this,
      );
      gameState.hintState = false;
    }
  }

  update() {
    if (
      gameState.hintState == true &&
      gameState.buttonState == '' &&
      gameState.wrong >= 1 &&
      gameState.wrong <= 2
    ) {
      // console.log("true");
      this.hintFunction();
      gameState.hintState = false;
    }

    if (
      gameState.buttonState == '_' &&
      gameState.hintClicked == false &&
      gameState.hintState == false &&
      gameState.wrong >= 1 &&
      gameState.wrong <= 2
    ) {
      // console.log("hi");
      this.hintButton.stop('breathe');
      this.hintButton.play('pop_out');
      this.hintButton.on(
        Phaser.Animations.Events.ANIMATION_COMPLETE_KEY + 'pop_out',
        () => {
          // begin=true;
          this.hintButton.setVisible(false);
        },
        this,
      );
      gameState.buttonState = '';
      gameState.hintState = false;
    }
  }
}
